<template>
    <FormField :required v-bind="otherProps">
        <template #default="{ inputId, touch }">
            <input :id="inputId" v-model="model" :type :required :placeholder @blur="onBlur(touch)" @change="touch" />
        </template>
        <template v-if="$slots.warning" #warning>
            <slot name="warning" />
        </template>
    </FormField>
</template>
<script setup lang="ts">
import type { FormInputProps } from "~/utils/types/FormFieldProps";

const model = defineModel<string | number>();

const { type = "text", required = true, ...otherProps } = defineProps<FormInputProps>();

const emit = defineEmits<{ blur: [] }>();

function onBlur(touch: () => void) {
    touch();
    emit("blur");
}
</script>
